import buildUrl from 'build-url';

export type TwitchScope =
  | 'with_prediction_scope'
  | 'with_read_followers'
  | 'with_read_subscriptions';

export const TwitchScopeUrl = (scope: TwitchScope) => {
  let scopeObject = {};
  scopeObject[scope] = true;
  return buildUrl('https://pulsoid.net', {
    path: 'oauth/twitch/initiate',
    queryParams: {
      redirect: window.location.href,
      ...scopeObject,
    },
  });
};
